import { useEffect,useState } from 'react';
const message = 'La date de fin doit être postérieure à la date de début'; //La date de début ne peut pas être supérieure à la date de fin.
export default function useDateRangeValidator(startDate, endDate) {
    const [isValidRangeDate, setIsValidRangeDate] = useState(false);
    const [messageRangeDate, setMessageRangeDate] = useState('');

    useEffect(() => {
        if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
            setIsValidRangeDate(true);
            setMessageRangeDate(message);
        } else {
            setIsValidRangeDate(false);
            setMessageRangeDate('');
        }
    }, [startDate, endDate]);

    return [isValidRangeDate, messageRangeDate];
}

export const getMessageFrom2DateDirectly = (startDate, endDate) => {
    if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
        return message;
    }
};